import { io } from "socket.io-client";

const BASE_URL = process.env.REACT_APP_API_BASE_URL?.replace(/\/v\d+\/?$/, "");

let socket;

export default function getSocket() {
  if (!socket) {
    socket = io(BASE_URL, {
      autoConnect: false,
      withCredentials: true,   // 🔑 IMPORTANT for cookies
      transports: ["websocket"] // optional, faster and more reliable
    });
  }

  return socket;
}
